import{_ as r}from"./_baseFlatten.js";var t=r;var a=function(r){return(null==r?0:r.length)?t(r,1):[]};export{a as f};
